exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.chooseBtn[data-v-44cd461e] {\n  line-height: normal;\n  height: 80px;\n  width: 190px;\n  margin-right: 0.5rem;\n}\n.chooseBtn.border-color-1[data-v-44cd461e] {\n    border-width: 2px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-44cd461e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/people/agents/AgentNewSelector.vue
// module id = 1218
// module chunks = 0